import Box from "@mui/material/Box";
import React, { FC, ReactNode, useState } from "react";
import { StyledToolbarContainer } from "./styled";

type CustomTooltipProps = {
  title: ReactNode;
  children: ReactNode;
};

const CustomBottomTooltip: FC<CustomTooltipProps> = ({ title, children }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      display="flex"
      alignItems="center"
      position="relative"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      {hovered && <StyledToolbarContainer>{title}</StyledToolbarContainer>}
    </Box>
  );
};

export default CustomBottomTooltip;
